import { AddButton } from '#app/components/AddButton/AddButton.js';
import { Text } from '#app/components/Primitives/Text.js';
import { getUrlHostname } from '#app/utilities/getUrlHostname.js';
import { GlobeOutlineIcon } from '@contra/icons/icons';
import { type ReactNode } from 'react';
import { styled } from 'styled-components';

const WebsiteLink = styled.a`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: fit-content;
  svg {
    margin-right: 6px;
  }
`;

const WebsiteDisplay = ({
  children,
  hostname,
  url,
  visitorCanEdit,
}: {
  readonly children: ReactNode;
  readonly hostname: null | string;
  readonly url: null | string;
  readonly visitorCanEdit: boolean;
}) => {
  if (visitorCanEdit) {
    return url && hostname ? (
      <WebsiteLink
        href={url}
        rel="nofollow noopener ugc"
        target="_blank"
      >
        {children}
      </WebsiteLink>
    ) : (
      <AddButton>Add a website</AddButton>
    );
  }

  return url && hostname ? (
    <WebsiteLink
      href={url}
      rel="nofollow noopener ugc"
      target="_blank"
    >
      {children}
    </WebsiteLink>
  ) : null;
};

export const Website = ({
  url,
  visitorCanEdit,
}: {
  readonly url: null | string;
  readonly visitorCanEdit: boolean;
}) => {
  const hostname = getUrlHostname(url);
  return (
    <WebsiteDisplay
      hostname={hostname}
      url={url}
      visitorCanEdit={visitorCanEdit}
    >
      <GlobeOutlineIcon size={16} />
      <Text textStyle={['bodySmall', 'bodyRegular']}>{hostname}</Text>
    </WebsiteDisplay>
  );
};
